module.exports = __webpack_public_path__ + "static/media/branding-img20.b2cd5805.jpg";